import React from 'react';
import styled, { css } from 'styled-components/macro';
import { isIE } from '../../utils/index';

/**
 * Pestañas que permiten navegar entre elecciones en la pantalla de estadísticas
 */


const TabsFilterListas = ({
  filtroPorSector,
  secFiltroPorSector,
  data,
  nomenclator,
}) => {
  const IE = isIE();
  const camaras = data.camaras;
  const sectores = nomenclator.sectores;
  return (
    <div css="width: 100%; display: flex; justify-content: space-around; background-color: white; padding-bottom: 10px;">
      {camaras.map(x => {
        return (
          <ButtonTab
            isselected={x.codcam === filtroPorSector}
            color={sectores[x.codcam].color}
            onClick={() => {
              secFiltroPorSector(x.codcam);
            }}
          >
            <SH2 isIE={IE}>{sectores[x.codcam].nombre}</SH2>
          </ButtonTab>
        );
      })}
    </div>
  );
};

export default TabsFilterListas;

const STabsEleccion = styled.article`
  height: 7rem;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding-left: 6rem;
  & button {
    background: none;
  }
`;
const SH2 = styled.h2`
  text-align: center;
  font-size: 14px;
  background-color: white;
  text-transform: uppercase;
  line-height: ${({ isIE }) => (isIE ? '14px' : '16px')};
  cursor: pointer;
  @media (max-width: 768px) {
    font-size: 10px;
    line-height: 12px;
   }
`;

const ButtonTab = styled(({ color, ...rest }) => <button {...rest} />)`
  width: 33%;
  height: ${({ isIE }) => (isIE ? '58px' : '62px')};
  background-color: white;
  border-bottom: 4px solid ${({ isselected, color }) => (isselected ? color : '#E5E5E5')};
  :hover {
    border-bottom: 4px solid ${({ color }) => color};
  font-weight: bold;
  }
  @media (max-width: 768px) {
    height: 83px;
    font-size:12px;
   }
`;

const selected = css`
  border-bottom: 4px solid #FFCC00;
  font-weight: bold;
`;
